module.exports = __webpack_public_path__ + "img/calendar.c570b22.svg";